<template>
  <a-modal
    :open="open"
    :title="title || `Request ${actionLabel}`"
    :ok-text="submitting ? 'Submitting…' : 'Submit request'"
    cancel-text="Cancel"
    :confirm-loading="submitting"
    @ok="submit"
    @cancel="$emit('update:open', false)"
  >
    <p style="margin-bottom: 8px">
      You don’t have permission to perform this action. Submit a request — a
      user with the required permission ({{ module }} / {{ action }}) can review
      and approve it.
    </p>
    <div class="form-group" style="margin-top: 12px">
      <label style="display: block; font-weight: 500; margin-bottom: 4px"
        >Reason (optional)</label
      >
      <a-textarea
        v-model:value="reason"
        :placeholder="`Why do you need to ${actionLabel.toLowerCase()}?`"
        :rows="3"
      />
    </div>
  </a-modal>
</template>

<script>
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

export default {
  name: "RequestActionModal",
  props: {
    open: { type: Boolean, default: false },
    module: { type: String, required: true },
    action: { type: String, required: true },
    actionType: { type: String, default: null },
    actionLabel: { type: String, default: "action" },
    title: { type: String, default: null },
    entityType: { type: String, required: true },
    entityId: { type: [String, Number], required: true },
    houseId: { type: [String, Number], default: null },
    payload: { type: Object, default: () => ({}) },
  },
  emits: ["update:open", "submitted"],
  data() {
    return { reason: "", submitting: false };
  },
  watch: {
    open(val) {
      if (val) this.reason = "";
    },
  },
  computed: {
    resolvedActionType() {
      return this.actionType || `${this.module}:${this.action}`;
    },
    resolvedHouseId() {
      return this.houseId || this.$getHouseId();
    },
  },
  methods: {
    submit() {
      if (!this.entityId || !this.entityType) {
        toast.error("Cannot submit request: missing entity details.");
        return;
      }
      if (!this.resolvedHouseId) {
        toast.error("Cannot submit request: no house selected.");
        return;
      }
      this.submitting = true;
      this.$store
        .dispatch("CREATE_ACTION_REQUEST", {
          token: this.$getAdminToken(),
          data: {
            action_type: this.resolvedActionType,
            entity_type: this.entityType,
            entity_id: this.entityId,
            house_id: this.resolvedHouseId,
            reason: this.reason || undefined,
            payload: this.payload || {},
          },
        })
        .then((res) => {
          this.submitting = false;
          if (res && res.data && res.data.status === "success") {
            toast.success(res.data.message || "Request submitted.");
            this.$emit("submitted", res.data);
            this.$emit("update:open", false);
          } else {
            toast.error(res?.data?.message || "Request failed.");
          }
        })
        .catch((err) => {
          this.submitting = false;
          toast.error(err?.response?.data?.message || "Request failed.");
        });
    },
  },
};
</script>
